import { takeLeading } from 'redux-saga/effects';
import { SubmitFormAction, SUBMIT_FORM } from '../actions/types';

export default function* takeFormSubmission(form: string, saga: (action: SubmitFormAction) => any) {
    yield takeLeading(action => action.type === SUBMIT_FORM && action.meta.form === form, saga);
}
